export enum FILTER_TYPE {
  STATUS = 'status-filters',
  SORT = 'sort',
  CREATED_BY = 'created-by',
  REQUEST_STATUS = 'request-status',
  MONETISATION_STATUS = 'monetisation-status',
  DATE_RANGE = 'date-range',
}

export enum SORT_ORDER {
  'ASC' = 'ASC',
  'DESC' = 'DESC',
}
